import React from 'react'
import ReactDOM from 'react-dom'
import {
  CSSReset,
  ChakraProvider,
  extendTheme,
  Box,
  Link,
  Heading,
  Center,
} from '@chakra-ui/react'

import ReactGA from 'react-ga'

if (process.env.NODE_ENV === 'production') {
  ReactGA.initialize('UA-165839355-3')
  if (typeof window !== `undefined`) {
    ReactGA.pageview(window.location.pathname + window.location.search)
  }
}

const theme = extendTheme()

ReactDOM.render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <CSSReset />

      {/* <Router> */}
      <Center pt={20} flexDir="column">
        <Heading as="h1" mb="4" size="xl">
          <span role="img" aria-label="waving hand">
            👋
          </span>{' '}
          Hola!
        </Heading>
        <Heading as="h1" size="md">
          Gracias por visitarnos una vez m&aacute;s!
        </Heading>
        <Box px="20" mt="8">
          Desde el 24 de mayo del 2022, el gobierno detuvo, sin mayores
          explicaciones, la publicaci&oacute;n de los datos de la pandemia
          causada por COVID-19. Así las cosas, los datos de esta aplicación no
          son actuales y han perdido su relevancia.
          <br />
          <br />
          Estoy muy agradecido por las miles de visitas y por tantos comentarios
          que recib&iacute;. Este proyecto me ayud&oacute; a pasar algunas
          semanas de la pandemia entretenido y aprendiendo mucho. No obstante,
          sin nuevos datos, he tomado la decisión de "apagar" este sitio.
          <br />
          <br />
          Esta página ya no será actualizada. Pero todavía pueden{' '}
          <Link
            textDecor="underline"
            href="mailto:hola@visual.cr?subject=COVID%20-%20"
          >
            enviarme un mensaje{' '}
            <span role="img" aria-label="Envelop">
              ✉️
            </span>
          </Link>
          <br />
          <br />
          Que estén bien.
        </Box>
      </Center>
    </ChakraProvider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.register();
